import type { GameStorage, SaveSlot } from "./GameStorage";
import type { GameSave } from "./GameSave";

/** In-memory storage: useful for tests and as a fallback when IndexedDB is unavailable. */
export class MemoryGameStorage implements GameStorage {
  private current: GameSave | null = null;
  private slots = new Map<string, { slot: SaveSlot; state: GameSave }>();

  load(): Promise<GameSave | null> {
    return Promise.resolve(this.current);
  }

  loadSlot(id: string): Promise<GameSave | null> {
    const entry = this.slots.get(id);
    return Promise.resolve(entry?.state ?? null);
  }

  save(state: GameSave, name?: string): Promise<SaveSlot> {
    const sceneId = state.world.currentSceneId;
    const slot: SaveSlot = {
      id: `save-${Date.now()}`,
      name: name ?? sceneId,
      timestamp: Date.now(),
      sceneId,
    };

    this.current = state;
    this.slots.set(slot.id, { slot, state });
    return Promise.resolve(slot);
  }

  autoSave(state: GameSave): Promise<void> {
    this.current = state;
    return Promise.resolve();
  }

  listSlots(): Promise<readonly SaveSlot[]> {
    return Promise.resolve([...this.slots.values()].map((e) => e.slot).filter((s) => !s.auto));
  }

  deleteSlot(id: string): Promise<void> {
    this.slots.delete(id);
    return Promise.resolve();
  }

  clear(): Promise<void> {
    this.current = null;
    this.slots.clear();
    return Promise.resolve();
  }
}
